<template>
<div class="ExcitationStep">
    <div class="container_box">
        <div class="content">
            <el-steps :active="stepValue" align-center>
                <el-step title="填写基本信息"></el-step>
                <el-step title="填写持股方式及来源"></el-step>
                <el-step title="填写相关要素"></el-step>
                <el-step title="生成报告"></el-step>
            </el-steps>
        </div>
    </div>

   <div class="page-module">
      <StepOne :formType="formType" @setStepValue="setStepValue"  v-show="stepValue === 0"></StepOne>
      <StepTwo :formType="formType" @setStepValue="setStepValue"  v-show="stepValue === 1" ref="steptwocomponents"></StepTwo>
      <StepThree :formType="formType" @setStepValue="setStepValue" @setfileInfo="setfileInfo" v-show="stepValue === 2" ref="stepthreecomponents"></StepThree>
      <StepFour :formType="formType" @setStepValue="setStepValue" :fileInfo="fileInfo" v-show="stepValue === 3" ref="stepfourcomponents"></StepFour>
   </div>
    <!-- <div class="page-module btnlist">
        <el-button @click="bbbbbbb" type="primary" plain>上一步</el-button>
        <el-button @click="aaaaaaaaaa" type="primary">下一步</el-button>
    </div> -->
</div>
</template>

<script>
import "animate.css/animate.min.css"
import StepOne from 'views/gujing/excitationTool/components/StepOne'
import StepTwo from 'views/gujing/excitationTool/components/StepTwo'
import StepThree from 'views/gujing/excitationTool/components/StepThree'
import StepFour from 'views/gujing/excitationTool/components/StepFour'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'ExcitationStep',
    data() {
        return {
            stepValue: 0,
            formType: {
              companyname: "",  // 公司名称
              regcapital: "",  // 注册资本-万元
              holdingtype: "1",  // 持股方式 1 通过自然人持股 2 通过有限公司持股 3 通过有限合伙企业持股
              ischangereg: "",  // 是否工商变更 0否 1是
              sharesource: "",  // 激励股份来源： 1 增资扩股 2 单一原股东转让 3 全体原股东等比例转让
              totalrate: "",  // 激励总量比例%
              totalsicount: "",  // 激励总量
              firstrate: "",  // 首次激励总量占总公司股份比例%
              firstsicount: "",  // 首次激励股份总量
              surrate: "",  // 预留股份占总公司股份比例
              sursicount: "",  // 预留激励总量占公司股份总量
              evmoney: "",  // 目前估值（万元）
            },
            fileInfo: {
              reportstatus: "", // 0失败  1成功
              fullurl: "", //  报告下载地址
              orderno: "",  // 订单号
            }
        }
    },
    
    beforeRouteLeave(to, from, next){// 当离开组件时，是否允许离开
        console.log(this.stepValue)
        if (this.stepValue < 3) {
            this.$confirm('您当前正在进行股权激励，退出不会保留当前填写数据', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                // 确定退出
                next()
            }).catch(() => {
                // 取消
            })
        } else {
            next()
        }
    },
    mounted() {},
    methods: {
        setfileInfo(data) {
          this.fileInfo = data
        },
        // 设置股权激励流程的步骤
        setStepValue(val) {
            this.stepValue = val
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        StepOne,
        StepTwo,
        StepThree,
        StepFour
    }
}
</script>

<style lang="scss" type="text/scss">
.el-message-box__btns {
    text-align: center;
    margin-bottom: 20px;
}
.el-message-box .el-message-box__content {
    padding: 40px 0;
    padding-top: 30px;
    text-align: center;
    color: #F56C6C;
}
.ExcitationStep {
    // filter: grayscale(100%);
    // -webkit-filter: grayscale(100%);
    // background-color: rgb(208, 229, 250);
    padding-top: 64px;
    .container_box {
        .content {
            padding: 40px 0;
            width: 1200px;
            margin: 0 auto;
            .el-steps {
                margin: 0 auto;
                width: 900px;
                .el-step {
                    width: 225px;
                }
                .el-step__line-inner {
                    border-width: 2px!important;
                    border-color: #409EFF;
                }
                .el-step__line {
                    height: 4px;
                    top: 10px;
                }
                .el-step__line {
                    background-color: #EAEFF6;
                }
                .el-step__icon {
                    background-color: #EAEFF6;
                    border-color: #EAEFF6;
                }
                .el-step__icon-inner {
                    color: #FFF;
                    font-weight: normal;
                }
                .is-finish{
                    .el-step__line {
                        background-color:#409EFF;
                    }
                }
                .is-finish, .is-process {
                    color: #108EE9;
                    .el-step__icon {
                        background-color: #108EE9;
                        border-color: #108EE9;
                    }
                    .el-step__icon-inner {
                        color: #FFF;
                    }
                }
            }
        }
    }
    .btnlist {
        margin-top: 62px;
        text-align: center;
        .el-button {
            width: 180px;
            height: 40px;
            border-radius: 6px;
            &~.el-button {
                margin-left: 30px;
            }
        }
    }
    .el-form-item__content img {
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 335px;
      width: 14px;
      height: 14px
    }
    .input {
      width: 320px;
      input {
        width: 100%;
      }
      &.txt {
        input {
          padding-right: 50px;
        }
      }
    }
    .tips_span {
      position: absolute;
      margin-left: -40px;
      color: #666;
    }
}
.tooltip_content{
        color: #666;
        /* text-align: center; */
        padding: 5px 10px;
        line-height: 20px;
        font-size: 14px;
    }
    .el-tooltip__popper.is-dark{
        background: #FFF;
        box-shadow:0px 0px 12px 0px rgba(0,0,0,0.06);
    }
    .el-tooltip__popper{
        padding: 5px;
    }
    .el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after{
        border-right-color: #FFF !important
    }
</style>